export default function (initialDataInteractor, questionnaireId, questionPosition, newQuestionData) {
  let questionnaire = initialDataInteractor.data.questionnaires.find(q => q.id == questionnaireId);
  if (questionPosition < questionnaire.questions.length && questionPosition >= 0) {
    questionnaire.questions.splice(questionPosition, 1, newQuestionData);
  }
}